/**
 * Slug safety helpers.
 *
 * Backend slugs must be URL-safe (`[a-z0-9-]`). Some live records violate this
 * (e.g. id 14 `ai/ml-computational-science-associate-e45928` — the `/` breaks
 * the `/walkin-drives/:slug` route, the canonical tag and the sitemap URL).
 * The durable fix is backend slug generation; these helpers are the frontend
 * guard so a bad slug can't structurally corrupt routing / canonical / sitemap.
 */

/** A slug we consider safe to place raw in a single URL path segment. */
export function isSafeSlug(slug) {
  return typeof slug === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/i.test(slug);
}

/**
 * Encode a slug for safe use in a URL path segment. Keeps a valid single
 * segment even when the raw slug contains `/`, spaces or other unsafe chars
 * (they become %-escapes), so React Router still matches one `:slug` param and
 * the browser round-trips it back to the original value for the API lookup.
 */
export function encodeSlug(slug) {
  return encodeURIComponent(String(slug ?? ''));
}
